import { takeLatest, put, call } from 'redux-saga/effects';
import { getMarketingSlotBanner } from 'yoda-interfaces/lib/Order/OrderApi';
import { getIrisMarketingSlotBanner } from 'yoda-interfaces/lib/Common/CommonHelper';
import {
    GET_MARKETING_SLOT_BANNER,
    GET_MARKETING_SLOT_BANNER_SUCCESS,
    GET_MARKETING_SLOT_BANNER_ERROR,
    GET_IRIS_MARKETING_SLOT_BANNER,
} from '../actionTypes/CartActionTypes';

function* watchMarketingSlotBannerSaga(action) {
    try {
        const marketingSlotBanner = yield call(getMarketingSlotBanner, action.payload);
        if (marketingSlotBanner.status === 200) {
            yield put({
                type: GET_MARKETING_SLOT_BANNER_SUCCESS,
                zoneInfo: marketingSlotBanner.data,
            });
        }
    } catch (error) {
        yield put({ type: GET_MARKETING_SLOT_BANNER_ERROR, error });
    }
}

function* watchIrisMarketingSlotBannerSaga(action) {
    try {
        const marketingSlotBanner = yield call(getIrisMarketingSlotBanner, action.payload);
        if (marketingSlotBanner.status === 200) {
            yield put({
                type: GET_MARKETING_SLOT_BANNER_SUCCESS,
                zoneInfo: marketingSlotBanner.data,
            });
        }
    } catch (error) {
        yield put({ type: GET_MARKETING_SLOT_BANNER_ERROR, error });
    }
}

const watchMarketingSlotBannerRequest = function* watchMarketingSlotBannerRequest() {
    yield takeLatest(GET_MARKETING_SLOT_BANNER, watchMarketingSlotBannerSaga);
    yield takeLatest(GET_IRIS_MARKETING_SLOT_BANNER, watchIrisMarketingSlotBannerSaga);
};
watchMarketingSlotBannerRequest.sagaName = 'watchMarketingSlotBannerRequest';

export default watchMarketingSlotBannerRequest;
